import React from "react";

function NotFoundPage(props) {
  return <div>NotFoundPage</div>;
}

export default NotFoundPage;
